interface SearchUsersFallbackProps {
  usersCount: number;
  isLoading: boolean;
  searchValue: string;
  searchFilter: string;
}

export function SearchUsersFallback({
  isLoading,
  usersCount,
  searchFilter,
  searchValue,
}: SearchUsersFallbackProps) {
  if (isLoading) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center py-10 text-center">
      {usersCount === 0 && (
        <div className="max-w-md space-y-2">
          <h3 className="text-2xl font-semibold">No Users Found</h3>

          <p className="text-sm text-muted-foreground">
            We couldn&apos;t find any users with <strong>{searchFilter}</strong>{' '}
            matching &quot;<em>{searchValue}</em>&quot;
          </p>
        </div>
      )}
    </div>
  );
}
